module.exports = __webpack_public_path__ + "img/warning.baa417b6.png";